import { createApiSlice } from "@common";
import { CRUD_PAYMENT_TERM } from "@routes";

const apiConfig = [
  {
    name: "addPaymentTerm",
    method: "post",
    url: CRUD_PAYMENT_TERM,
    stateKey: "message",
  },
  {
    name: "getPaymentTerm",
    method: "get",
    url: CRUD_PAYMENT_TERM,
    stateKey: "data",
  },
  {
    name: "updatePaymentTerm",
    method: "put",
    url: CRUD_PAYMENT_TERM,
    stateKey: "message",
  },
  {
    name: "deletePaymentTerm",
    method: "delete",
    url: CRUD_PAYMENT_TERM,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"paymentTerm",
 apiConfig, 
 customReducers);
const paymentTermSlice = slice;

export default paymentTermSlice.reducer;

export const {
  addPaymentTerm,
  getPaymentTerm,
  updatePaymentTerm,
  deletePaymentTerm,
} = thunks;

export const { rowSelect } = actions;
